import * as Yup from 'yup';
import * as moment from 'moment';
import { BIDFORMAT } from '../utils/dateOfBirthValidation';

export function getPostInitialValues(checkoutPageData, urlObject) {
    let curShippingModeValue, locationsDaysOfOperationList;

    if (urlObject?.type === 'buyerInvCheckoutbuynowcpu') {
        curShippingModeValue = 'PICKUP';
    } else {
        curShippingModeValue = checkoutPageData?.shippingMode;
    }

    if (curShippingModeValue === 'PICKUP') {
        locationsDaysOfOperationList = checkoutPageData?.pickupOperationDetails?.locationDaysOfOperations;
    } else {
        locationsDaysOfOperationList = checkoutPageData?.deliveryOperationDetails?.locationDaysOfOperations;
    }

    let checkOutStartTimeBuyerOfferValue, checkOutEndTimeBuyerOfferValue, checkOutAltStartTimeBuyerOfferValue, checkOutAltEndTimeBuyerOfferValue
    if (curShippingModeValue === 'DELIVERY') {
        checkOutStartTimeBuyerOfferValue = checkoutPageData?.deliveryOperationDetails?.operationsHourStart
        checkOutEndTimeBuyerOfferValue = checkoutPageData?.deliveryOperationDetails?.operationsHourEnd
        checkOutAltStartTimeBuyerOfferValue = checkoutPageData?.deliveryOperationDetails?.operationsHourStart
        checkOutAltEndTimeBuyerOfferValue = checkoutPageData?.deliveryOperationDetails?.operationsHourEnd
    } else {
        checkOutStartTimeBuyerOfferValue = checkoutPageData?.pickupOperationDetails?.operationsHourStart
        checkOutEndTimeBuyerOfferValue = checkoutPageData?.pickupOperationDetails?.operationsHourEnd
        checkOutAltStartTimeBuyerOfferValue = checkoutPageData?.pickupOperationDetails?.operationsHourStart
        checkOutAltEndTimeBuyerOfferValue = checkoutPageData?.pickupOperationDetails?.operationsHourEnd
    }

    let dateSet = new Date();
    let bidDate = moment(dateSet).format(BIDFORMAT);

    function adjustDateToAllowedDays(minDOBirth, allowedDays) {
        let dayOfWeek = allowedDays.indexOf(getDayName(minDOBirth.getDay()));
        // Check if the day of the week is allowed
        if (allowedDays.includes(getDayName(dayOfWeek))) {
            return minDOBirth;
        }
        // Find the next available day in the allowedDays array
        let nextAvailableDay = allowedDays.find(day => {
            return allowedDays.indexOf(day) > dayOfWeek;
        });
        // If no next available day is found, set it to the first day in the array
        if (!nextAvailableDay) {
            nextAvailableDay = allowedDays[0];
        }
        // Calculate the number of days to add to reach the next available day
        let daysToAdd = allowedDays.indexOf(nextAvailableDay) - dayOfWeek;
        // Adjust the date
        minDOBirth.setDate(minDOBirth.getDate() + daysToAdd);
        return minDOBirth;
    }
    // Function to get the name of the day from the index
    function getDayName(index) {
        const days = ["SUNDAY", "MONDAY", "TUESDAY", "WEDNESDAY", "THURSDAY", "FRIDAY", "SATURDAY"];
        return days[index];
    }

    let checkoutMinDateValue = new Date();

    if (urlObject?.type === 'buyerInvCheckoutmakeAltOffer') {
        checkoutMinDateValue.setHours(new Date(bidDate).getHours() + 24); // Add 48 hours
      } else {
        if (checkoutPageData.leadTime) {
          checkoutMinDateValue.setHours(new Date(bidDate).getHours() + 24); // Add 24 hours initially      
          // Adjust to the next day if needed
          if (new Date().getHours() > checkoutPageData.leadTime) {
            checkoutMinDateValue.setDate(new Date().getDate() + 1);
          }      
          checkoutMinDateValue.setHours(new Date(bidDate).getHours() + checkoutPageData.leadTime); // Add leadTime hours
          checkoutMinDateValue = adjustDateToAllowedDays(checkoutMinDateValue, locationsDaysOfOperationList);
        }
      }

    return {
        //for buyer need and seller inv     
        name: checkoutPageData?.shippingAddress?.locationName,
        line1: checkoutPageData?.shippingAddress?.address1,
        line2: checkoutPageData?.shippingAddress?.address2,
        city: checkoutPageData?.shippingAddress?.city,
        state: checkoutPageData?.shippingAddress?.state,
        zip: checkoutPageData?.shippingAddress?.zipCode,

        // for buyer inv
        deliveryname: checkoutPageData?.deliveryAddress?.locationName,
        deliveryline1: checkoutPageData?.deliveryAddress?.address1,
        deliveryline2: checkoutPageData?.deliveryAddress?.address2,
        deliverycity: checkoutPageData?.deliveryAddress?.city,
        deliverystate: checkoutPageData?.deliveryAddress?.state,
        deliveryzip: checkoutPageData?.deliveryAddress?.zipCode,
        pickupname: checkoutPageData?.pickupAddress?.locationName,
        pickupline1: checkoutPageData?.pickupAddress?.address1,
        pickupline2: checkoutPageData?.pickupAddress?.address2,
        pickupcity: checkoutPageData?.pickupAddress?.city,
        pickupstate: checkoutPageData?.pickupAddress?.state,
        pickupzip: checkoutPageData?.pickupAddress?.zipCode,
        brokername: '',
        brokerline1: '',
        brokerline2: '',
        brokercity: '',
        brokerstate: '',
        brokerzip: '',
        cardTypeRadio: '',
        paymentMethod: '',
        // these are for buyer accepting the bid on posted needs
        deliveryDateCheckout: checkoutPageData?.requestedDate ? moment(checkoutPageData?.requestedDate).format('MM/DD/YYYY') : bidDate,
        beginTimeCheckOut: checkoutPageData?.appointmentStartTime || '08:00',
        endTimeCheckOut: checkoutPageData?.appointmentEndTime || '17:00',
        // these are for buyer making offer on inventory
        offerAmount: '',
        invCheckoutIsAltQty: 'altqtyno',
        offerQty: checkoutPageData.qty,
        maxOfferQty: checkoutPageData.originalQty || checkoutPageData.qty,
        invCheckoutIsAltMode: 'altmodeno',
        curentShippingMode: curShippingModeValue,
        invCheckoutIsAltDate: (urlObject?.type === 'buyerInvCheckoutmakeAltOffer') ? 'altdateyes' : '',
        checkOutDateBuyerOffer: checkoutPageData?.requestedDate ? moment(checkoutPageData?.requestedDate).format('MM/DD/YYYY') : bidDate,
        checkOutDateBuyerOfferMinDate: checkoutMinDateValue ? moment(checkoutMinDateValue).format('MM/DD/YYYY') : bidDate,
        checkOutStartTimeBuyerOffer: checkOutStartTimeBuyerOfferValue || '08:00',
        checkOutEndTimeBuyerOffer: checkOutEndTimeBuyerOfferValue || '17:00',

        //for alt modes
        checkOutAltDateBuyerOffer: checkoutPageData?.requestedDate ? moment(checkoutPageData?.requestedDate).format('MM/DD/YYYY') : bidDate,
        checkOutAltStartTimeBuyerOffer: checkOutAltStartTimeBuyerOfferValue || '08:00',
        checkOutAltEndTimeBuyerOffer: checkOutAltEndTimeBuyerOfferValue || '17:00',

        shippingMode: checkoutPageData?.shippingMode || 'DELIVERY',
        confirmBid: false,
        poNumber: checkoutPageData?.ptPlusDetails?.poNumber || checkoutPageData?.poNumber ||'',
        achBackUpCard: '',
        achSelected: false,
        achAcknowledgeCheck: false,
        pickupRequestSellerAcknowledgeCheck: false,
        deliveryRequestSellerAcknowledgeCheck: false,
        referenceNumber: checkoutPageData?.ptPlusDetails?.orderRefNumber || '',
        checkoutPromoCode: '',
        promoCodeVaidated: false,
        note: '',
    }
}

export function getValidateSchema(checkoutPageData) {
    // though this a common scheme for both buyer need and inv, it is used only for buyer inv checkout page
    let schemaAttributes = {
        deliveryname: Yup.string().trim().required("Company name is required."),
        deliveryline1: Yup.string().trim().required("Address Line 1 is required."),
        deliverycity: Yup.string().trim().required("City is required."),
        deliverystate: Yup.string().trim().required("State is required."),
        deliveryzip: Yup.string().trim().required("Zip is required."),
    };
    return Yup.object().shape(schemaAttributes);
}